import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Button, Modal, Row, Col } from "react-bootstrap";
import { baseUrl } from "../../../Utility/constants";

const EditSchoolDetailsModal = ({
  show,
  handleEditModalClose,
  handleSubmit,
  formData,
  setFormData,
}) => {
  const [dropdowns, setDropdowns] = useState({
    grantTypes: [],
    streams: [],
    schoolTypes: [],
    attachTypes: [],
    locations: [],
    schoolTimings: [],
    sessionMaster: [],
    schoolMedium: [],
  });

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [
          grantTypeRes,
          streamRes,
          schoolTypeRes,
          attachTypeRes,
          locationRes,
          schoolTimingRes,
          sessionMasterRes,
          schoolMediumRes,
        ] = await Promise.all([
          axios.get(`${baseUrl}/api/CommonMaster/GetGrantTypeMasters`),
          axios.get(`${baseUrl}/api/StreamMaster`),
          axios.get(`${baseUrl}/api/CommonMaster/GetSchoolTypeMasters`),
          axios.get(`${baseUrl}/api/CommonMaster/GetAttachTypeMasters`),
          axios.get(`${baseUrl}/api/CommonMaster/GetLocationMasters`),
          axios.get(`${baseUrl}/api/CommonMaster/GetSchoolTimingsMasters`),
          axios.get(`${baseUrl}/api/SessionMaster`),
          axios.get(`${baseUrl}/api/CommonMaster/GetSchoolMediumMasters`),
        ]);

        setDropdowns({
          grantTypes: grantTypeRes.data,
          streams: streamRes.data,
          schoolTypes: schoolTypeRes.data,
          attachTypes: attachTypeRes.data,
          locations: locationRes.data,
          schoolTimings: schoolTimingRes.data,
          sessionMaster: sessionMasterRes.data,
          schoolMedium: schoolMediumRes.data,
        });
      } catch (error) {
        console.log("Failed to fetch dropdown data");
      }
    };

    fetchDropdowns();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleMultiSelectChange = (e) => {
    const { name, options } = e.target;
    const selectedValues = Array.from(options)
      .filter((option) => option.selected)
      .map((option) => option.value)
      .join(",");

    setFormData({
      ...formData,
      [name]: selectedValues,
    });
  };

  const getSelectedValues = (values) =>
    (Array.isArray(values) ? values : String(values || "").split(","))
      .map((value) => String(value).trim())
      .filter(Boolean);

  const getSchoolMediumIds = (schoolMedium) => {
    const selectedValues = Array.isArray(schoolMedium)
      ? schoolMedium
      : String(schoolMedium || "").split(",");

    return selectedValues
      .map((value) => {
        const selectedValue = String(value).trim();
        const medium = dropdowns.schoolMedium.find(
          (option) =>
            String(option.id) === selectedValue || option.name === selectedValue
        );
        return medium ? String(medium.id) : selectedValue;
      })
      .filter(Boolean)
      .join(",");
  };

  const submitForm = () => {
    const updatedFormData = {
      ...formData,
      attachTypes: formData.attachTypes.split(",").map(Number),
      grantTypes: getSelectedValues(formData.grantTypes).join(","),
      streams: formData.streams.split(",").map(Number),
      schoolMedium: getSchoolMediumIds(formData.schoolMedium),
    };
    handleSubmit(updatedFormData);
  };

  const formatDateString = (dateString) => {
    if (!dateString) return ""; // Handle undefined or null values
    return dateString.split("T")[0]; // Extract YYYY-MM-DD part
  };

  // Handle file uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    setFormData({
      ...formData,
      [name]: file,
    });
  };

  return (
    <Modal
      show={show}
      onHide={handleEditModalClose}
      dialogClassName="custom-modal-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Update School Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Form onSubmit={submitForm}> */}
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm();
          }}
        >
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formOrganizationName">
                <Form.Label>Organization Name</Form.Label>
                <Form.Control
                  type="text"
                  name="organizationName"
                  value={formData.organizationName}
                  onChange={handleInputChange}
                  placeholder="Enter organization name"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formEstablishmentYear">
                <Form.Label>Establishment Year</Form.Label>
                <Form.Control
                  type="number"
                  name="establishmentYear"
                  value={formData.establishmentYear}
                  onChange={handleInputChange}
                  maxLength={4}
                  minLength={4}
                  placeholder="Enter establishment year"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formSchoolOrCollegeName">
                <Form.Label>School/College Name</Form.Label>
                <Form.Control
                  type="text"
                  name="schoolOrCollegeName"
                  value={formData.schoolOrCollegeName}
                  onChange={handleInputChange}
                  placeholder="Enter school/college name"
                />
              </Form.Group>
            </Col>
            {/* <Col md={3}>
              <Form.Group controlId="formSessionID">
                <Form.Label>Session</Form.Label>
                <Form.Control
                  as="select"
                  name="sessionID"
                  value={formData.sessionID}
                  onChange={handleInputChange}
                >
                  <option value="">Select Session</option>
                  {dropdowns.sessionMaster.map((session) => (
                    <option key={session.sessionId} value={session.sessionId}>
                      {session.sessionName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col> */}
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formLocation">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  as="select"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                >
                  <option value="">Select Location</option>
                  {dropdowns.locations.map((loc) => (
                    <option key={loc.id} value={loc.locationName}>
                      {loc.locationName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formUdiseNo">
                <Form.Label>UDISE No</Form.Label>
                <Form.Control
                  type="number"
                  name="udiseNo"
                  value={formData.udiseNo}
                  onChange={handleInputChange}
                  placeholder="Enter UDISE No"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formSSC10thIndexNo">
                <Form.Label>SSC 10th Index No</Form.Label>
                <Form.Control
                  type="text"
                  name="ssC10thIndexNo"
                  value={formData.ssC10thIndexNo}
                  onChange={handleInputChange}
                  placeholder="Enter SSC 10th Index No"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formHSC12thIndexNo">
                <Form.Label>HSC 12th Index No</Form.Label>
                <Form.Control
                  type="text"
                  name="hsC12thIndexNo"
                  value={formData.hsC12thIndexNo}
                  onChange={handleInputChange}
                  placeholder="Enter HSC 12th Index No"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formSchoolType">
                <Form.Label>School Type</Form.Label>
                <Form.Control
                  as="select"
                  name="schoolType"
                  value={formData.schoolType}
                  onChange={handleInputChange}
                >
                  <option value="">Select School Type</option>
                  {dropdowns.schoolTypes.map((type) => (
                    <option key={type.id} value={type.name}>
                      {type.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formSchoolMedium">
                <Form.Label>School Medium</Form.Label>
                <Form.Control
                  as="select"
                  multiple
                  name="schoolMedium"
                  value={getSchoolMediumIds(formData.schoolMedium).split(",").filter(Boolean)}
                  onChange={handleMultiSelectChange}
                >
                  {dropdowns.schoolMedium.map((medium) => (
                    <option key={medium.id} value={medium.id}>
                      {medium.name}
                    </option>
                  ))}                  
                </Form.Control>
              </Form.Group>
            </Col>          
            <Col md={3}>
              <Form.Group controlId="formSchoolOrCollegeTiming">
                <Form.Label>School/College Timing</Form.Label>
                <Form.Control
                  as="select"
                  name="schoolOrCollegeTiming"
                  value={formData.schoolOrCollegeTiming}
                  onChange={handleInputChange}
                >
                  <option value="">Select Timing</option>
                  {dropdowns.schoolTimings.map((timing) => (
                    <option key={timing.id} value={timing.timing}>
                      {timing.timing}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
         
            <Col md={3}>
              <Form.Group controlId="formSchoolRecognitionNumber">
                <Form.Label>School Recognition Number</Form.Label>
                <Form.Control
                  type="text"
                  name="schoolRegistrationNumber"
                  value={formData.schoolRegistrationNumber}
                  onChange={handleInputChange}
                  placeholder="School Recognition Number"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Additional fields */}
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formSchoolRecognitionDate">
                <Form.Label>School Recognition Date</Form.Label>
                <Form.Control
                  type="date"
                  name="schoolRegistrationDate"
                  value={formatDateString(formData.schoolRegistrationDate)}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formSSC10thIndexNo">
                <Form.Label>College Recognition Number</Form.Label>
                <Form.Control
                  type="text"
                  name="collegeRegistrationNumber"
                  value={formData.collegeRegistrationNumber}
                  onChange={handleInputChange}
                  placeholder="College Recognition Number"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formCollegeRecognitionDate">
                <Form.Label>College Recognition Date</Form.Label>
                <Form.Control
                  type="date"
                  name="collegeRegistrationDate"
                  value={formatDateString(formData.collegeRegistrationDate)}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
            <br></br>
              <Form.Group controlId="formIsNightSchoolOrCollege">
                <Form.Check
                  type="checkbox"
                  name="isNightSchoolOrCollege"
                  checked={formData.isNightSchoolOrCollege}
                  onChange={handleInputChange}
                  label="Is Night School/College?11"
                />
              </Form.Group>
              <Form.Group controlId="formLCNaming">
                              <Form.Check
                                type="checkbox"
                                name="lcNamingPrint"
                                checked={formData.lcNamingPrint}
                                onChange={handleInputChange}
                                label="Naming : Last-First-Middle "
                              />
                            </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGrantTypes">
                <Form.Label>Grant Types</Form.Label>
                <Form.Control
                  as="select"
                  name="grantTypes"
                  multiple
                  value={getSelectedValues(formData.grantTypes)}
                  onChange={handleMultiSelectChange}
                >
                  {dropdowns.grantTypes.map((grant) => (
                    <option key={grant.id} value={grant.id}>
                      {grant.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formAttachType">
                <Form.Label>Attach Type</Form.Label>
                <Form.Control
                  as="select"
                  name="attachTypes"
                  multiple
                  value={formData.attachTypes.split(",")}
                  onChange={handleMultiSelectChange}
                >
                  {dropdowns.attachTypes.map((attach) => (
                    <option key={attach.id} value={attach.id}>
                      {attach.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>			

            <Col md={3}>
              <Form.Group controlId="formStreams">
                <Form.Label>Streams</Form.Label>
                <Form.Control
                  as="select"
                  name="streams"
                  multiple
                  value={formData.streams.split(",")}
                  onChange={handleMultiSelectChange}
                >
                  {dropdowns.streams.map((stream) => (
                    <option key={stream.id} value={stream.id}>
                      {stream.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Logo</Form.Label>
                <Form.Control
                  type="file"
                  name="Logo"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Signature</Form.Label>
                <Form.Control
                  type="file"
                  name="PrincipalSignture"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Stamp</Form.Label>
                <Form.Control
                  type="file"
                  name="SchoolCollegeStamp"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleEditModalClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditSchoolDetailsModal;
